import React from "react";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div
      className="ui-skin-app-shell relative min-h-screen min-h-[100dvh] bg-background"
    >
      {children}
      {/* Toasts render from the sonner <Toaster /> mounted in App.tsx. */}
    </div>
  );
}

export default AppLayout;
